// Aufklappbare Zeile für die Admin-Konsole — von Apps-Tab und APIs-Tab benutzt.
//
// Herausgezogen, als der APIs-Tab dieselbe Gestalt brauchte wie der Apps-Tab. Eine
// zweite Kopie hätte bedeutet, Pfeil, Zustandsklasse und aria-expanded künftig an
// zwei Stellen gleich zu halten.

/** CSS dieses Moduls, damit die Konsole es einmalig mit einhängen kann. */
export const AKKORDEON_CSS = `
.mednos-akk {
  border: 1px solid rgba(255, 255, 255, 0.1); border-radius: 8px; overflow: hidden;
}
.mednos-akk__kopf {
  width: 100%; display: flex; align-items: center; gap: 10px;
  padding: 10px 12px; border: none; background: transparent; color: #fff;
  font-family: inherit; font-size: 0.88rem; font-weight: 500;
  cursor: pointer; text-align: left;
}
.mednos-akk__kopf:hover { background: rgba(255, 255, 255, 0.05); }
.mednos-akk__zusatz { font-size: 0.72rem; color: #b0b0b0; }
.mednos-akk__pfeil {
  margin-left: auto; font-size: 0.7rem; color: #b0b0b0;
  transition: transform 0.15s;
}
.mednos-akk.is-offen .mednos-akk__pfeil { transform: rotate(90deg); }
.mednos-akk__inhalt {
  display: none; flex-direction: column; gap: 8px;
  padding: 4px 12px 12px;
}
.mednos-akk.is-offen .mednos-akk__inhalt { display: flex; }
`;

/**
 * Eine aufklappbare Zeile. Startet zugeklappt, sofern nicht anders verlangt.
 *
 * @param {string} titel Beschriftung links
 * @param {string} zusatz Kleiner grauer Zusatz daneben (Host, Anzahl, …); '' blendet ihn aus
 * @param {Node[]} inhalt Was beim Aufklappen erscheint
 * @param {boolean} [offenStarten] Aufgeklappt starten — z. B. wenn man nach dem
 *   Freischalten genau hierher zurueckkehrt
 * @returns {HTMLElement}
 */
export function akkordeonEintrag(titel, zusatz, inhalt, offenStarten = false) {
  const eintrag = document.createElement('div');
  eintrag.className = offenStarten ? 'mednos-akk is-offen' : 'mednos-akk';

  const kopf = document.createElement('button');
  kopf.type = 'button';
  kopf.className = 'mednos-akk__kopf';
  const titelEl = document.createElement('span');
  titelEl.textContent = titel;
  kopf.append(titelEl);
  if (zusatz) {
    const zusatzEl = document.createElement('span');
    zusatzEl.className = 'mednos-akk__zusatz';
    zusatzEl.textContent = zusatz;
    kopf.append(zusatzEl);
  }
  const pfeil = document.createElement('span');
  pfeil.className = 'mednos-akk__pfeil';
  pfeil.textContent = '▶';
  kopf.append(pfeil);
  kopf.setAttribute('aria-expanded', String(offenStarten));

  const inhaltEl = document.createElement('div');
  inhaltEl.className = 'mednos-akk__inhalt';
  inhaltEl.append(...inhalt);

  kopf.addEventListener('click', () => {
    const offen = eintrag.classList.toggle('is-offen');
    kopf.setAttribute('aria-expanded', String(offen));
  });

  eintrag.append(kopf, inhaltEl);
  return eintrag;
}
